export default {
	title: "Уровень Vip",
	current: "Текущий уровень VIP",
	status: {
		btn: ["Активировано", "Зарегистрироваться сейчас"]
	}
};
